<div class="user-information__user">
  <div class="user-information__row">
    <span class="user-information__label">{{ label | translate }}</span>

    <span class="user-information__value" [ngClass]="statusClass">
      @if (Array.isArray(value)) {
        {{ value.join(', ') }}
      } @else {
        {{ value }}
      }
    </span>
  </div>
</div>
